<template>
    <PageComponent 
        :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
        :addButtonLabel="addButtonLabel"
        @handleAddNew="addNewCampaign"
        :searchFilters="searchFilters"
        :dropdownOptions="dropdownOptions"
        @handleDynamicOption="handleDynamicOption"
        @searchPage="searchCampaigns"
        @resetFilters="resetFilters"
        @removeItem="removeCampaign"
        @removeSelectedItems="removeCampaigns"
        :addingRight="addingRight"
        :removingRight="removingRight"
        :rightsModule="rightsModule"
        :columns="tableColumns"
        :rows="campaignsList"
        :actions="actions"
        :idField="idField"
        @handleSelectionChange="handleSelectionChange"
        @handleActionClick="handleActionClick"
        @handleShowDetails="handleShowDetails"
        :count="depCount"
        :currentPage="currentPage"
        :result="depArrLen"
        @loadPrev="loadPrev"
        @loadNext="loadNext"
        @firstPage="firstPage"
        @lastPage="lastPage"
        :showNextBtn="showNextBtn"
        :showPreviousBtn="showPreviousBtn"
        :selectedValue="selectedValue"
        @selectSearchQuantity="selectSearchQuantity"
        :showDetails="showDetails"
        :detailsTitle="detailsTitle"
        @hideDetails="hideDetails"
    >
    <div>
        <div class="tabs pt-1">
            <button v-for="(tab, index) in tabs" :key="tab" :class="['tab', { active: activeTab === index }]"@click="selectTab(index)">
                {{ tab }}
            </button>
        </div>
        <div class="tab-content mt-3">
            <div v-show="activeTab == 0">
                <div class="border border-slate-200 rounded relative py-2 w-[75%] px-2 min-h-[250px]">                    
                    <ShowDetailsTable :key="tableKey" :columns="channelColumns" :rows="channelsRows" :displayButtons="displayDetailsButtons" :fields="channelsField" :idField="idFieldChannel" @handleSelectionChange="handleChannelChange" :showActions=false :rightsModule="rightsModule" />
                </div>
            </div>
            <div v-show="activeTab == 1">
                <div class="border border-slate-200 rounded relative py-2 w-[75%] px-2 min-h-[250px]">                    
                    <ShowDetailsTable :key="tableKey" :columns="assetColumns" :rows="assetsRows" :displayButtons="displayDetailsButtons" :fields="assetsField" :idField="idFieldAsset" @handleSelectionChange="handleAssetChange" :showActions=true :actions="assetActions" @handleActionClick="handleAssetActionClick" :rightsModule="rightsModule" />
                </div>
            </div>
            <div v-show="activeTab == 2">
                <div class="border border-slate-200 rounded relative py-2 w-[75%] px-2 min-h-[250px]">                    
                    <ShowDetailsTable :key="tableKey" :columns="metricColumns" :rows="metricsRows" :displayButtons="displayDetailsButtons" :fields="metricsField" :idField="idFieldMetric" @handleSelectionChange="handleMetricChange" :showActions=false :rightsModule="rightsModule" />
                </div>
            </div>
            <div v-show="activeTab == 3">
                <div class="border border-slate-200 rounded relative py-2 w-[75%] px-2 min-h-[250px]">                    
                    <ShowDetailsTable :key="tableKey" :columns="roiColumns" :rows="roiRows" :displayButtons="displayDetailsButtons" :fields="roiField" :idField="idFieldRoi" @handleSelectionChange="handleRoiChange" :showActions=false :rightsModule="rightsModule" />
                </div>
            </div>
        </div>
        
    </div>
    </PageComponent>    
    <MovableModal v-model:visible="depModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
        :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader"  @closeModal="closeModal">
        <DynamicForm 
            :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="saveCampaign" @handleReset="handleReset"
        />
    </MovableModal>
    <MovableModal v-model:visible="chanModalVisible" :title="title1" :modal_top="modal_top1" :modal_left="modal_left1" :modal_width="modal_width1"
        :loader="modal_loader1" @showLoader="showModalLoader1" @hideLoader="hideModalLoader1" @closeModal="closeModal1">
        <DynamicForm 
            :fields="formFields1" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="addChannel" @handleReset="handleReset"
        />
    </MovableModal>
    <MovableModal v-model:visible="assetModalVisible" :title="title2" :modal_top="modal_top1" :modal_left="modal_left1" :modal_width="modal_width1"
        :loader="modal_loader1" @showLoader="showModalLoader1" @hideLoader="hideModalLoader1" @closeModal="closeModal1">
        <DynamicForm 
            :fields="formFields2" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="createAsset" @file-changed="handleFileChange" @handleReset="handleReset"
        />
    </MovableModal>
    <MovableModal v-model:visible="metricModalVisible" :title="title3" :modal_top="modal_top1" :modal_left="modal_left1" :modal_width="modal_width1"
        :loader="modal_loader1" @showLoader="showModalLoader1" @hideLoader="hideModalLoader1" @closeModal="closeModal1">
        <DynamicForm 
            :fields="formFields3" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="createMetric" @handleReset="handleReset"
        />
    </MovableModal>
    <MovableModal v-model:visible="roiModalVisible" :title="title4" :modal_top="modal_top1" :modal_left="modal_left1" :modal_width="modal_width1"
        :loader="modal_loader1" @showLoader="showModalLoader1" @hideLoader="hideModalLoader1" @closeModal="closeModal1">
        <DynamicForm 
            :fields="formFields4" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="createRoi" @handleReset="handleReset"
        />
    </MovableModal>
    <PrintModal v-model:visible="printModalVisible" :title="printTitle" >
        <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="100%" type="application/pdf" style="border: none;"></iframe>
    </PrintModal>
</template>

<script>
import axios from "axios";
import { ref, computed, watch, onMounted, onBeforeMount } from 'vue';
import PageComponent from '@/components/PageComponent.vue'
import MovableModal from '@/components/MovableModal.vue'
import ShowDetailsTable from '@/components/ShowDetailsTable.vue';
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import Swal from 'sweetalert2';
import PrintModal from '@/components/PrintModal.vue';

export default{
    name: 'Marketing_Campaigns',
    components:{
        PageComponent,MovableModal,DynamicForm,ShowDetailsTable,PrintModal
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const loader = ref('');
        const modal_loader = ref('none');
        const modal_loader1 = ref('none');
        const title = ref('Campaign Details');
        const title1 = ref('Add Campaign Channel');
        const title2 = ref('Add Campaign Asset');
        const title3 = ref('Add Campaign Metric');
        const title4 = ref('Add Campaign ROI');
        const addButtonLabel = ref('New Campaign');
        const addingRight = ref('Adding Marketing Campaigns');
        const removingRight = ref('Deleting Marketing Campaigns');
        const rightsModule = ref('CRM');
        const idField = 'campaign_id';
        const depModalVisible = ref(false);
        const chanModalVisible = ref(false);
        const assetModalVisible = ref(false);
        const metricModalVisible = ref(false);
        const roiModalVisible = ref(false);
        const printModalVisible = ref(false);
        const pdfUrl = ref(null);
        const printTitle = ref('Preview Campaign Asset Document');
        const campaignsList = ref([]);
        const selectedIds = ref([]);
        const depResults = ref([]);
        const depArrLen = ref(0);
        const depCount = ref(0);
        const pageCount = ref(0);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const showDetails = ref(false);
        const detailsTitle = ref('Campaign Details');
        const activeTab = ref(0);
        const campaignID = ref(null);
        const channelID = ref(null);
        const custComponentKey = ref(0);
        const channelArray = computed(() => store.state.Marketing_Channels.channelArr);
        const tabs = ref(['Campaign Channels', 'Campaign Assets', 'Campaign Metrics', 'Campaign ROI']);
        const selectedValue = ref(50);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('200px');
        const modal_top1 = ref('200px');
        const modal_left = ref('400px');
        const modal_left1 = ref('400px');
        const modal_width = ref('50vw');
        const modal_width1 = ref('30vw');
        const isEditing = computed(()=> store.state.Marketing_Campaigns.isEditing);
        const channelEditing = ref(false);
        const upload_file = ref('');
        const filePath = ref('');
        const computedFilePath = ref('');
        const selectedCampaign = computed(()=> store.state.Marketing_Campaigns.selectedCampaign);
        const selectedChannel = computed(()=> store.state.Marketing_Campaigns.selectedChannel);
        const channelName = computed(()=> store.state.Marketing_Campaigns.channelName);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Name", key: "name", type: "text"},
            {label: "Objective", key: "objective", type: "text"},
            {label: "Start Date", key: "start_date", type: "text"},
            {label: "End Date", key: "end_date", type: "text"},
            {label: "Budget", key: "budget", type: "text"},
            {label: "Assigned To", key: "assigned_to", type: "text"},
            {label: "Status", key: "status", type: "text", textColor: "textColor"},

        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Campaign', rightName: 'Editing Marketing Campaigns'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Campaign', rightName: 'Deleting Marketing Campaigns'},
        ])
        const channelColumns = ref([
            {type: "checkbox"},
            {label: "Channel Name", key: "channel.name"},
            {label: "Allocated Budget", key: "formatted_allocated_budget"},
            {label: "Actual Spend", key: "formatted_actual_spend"},
            {label: "Leads Generated", key: "formatted_leads_generated"},
        ])
        const assetColumns = ref([
            {type: "checkbox"},
            {label: "Asset Name", key: "name"},
            {label: "Asset Type", key: "asset_type"},
        ])
        const metricColumns = ref([
            {type: "checkbox"},
            {label: "Date", key: "date"},
            {label: "Impressions", key: "impressions"},
            {label: "Clicks", key: "clicks"},
            {label: "Leads Generated", key: "leads_generated"},
            {label: "Conversions", key: "conversions"},
        ])
        const roiColumns = ref([
            {type: "checkbox"},
            {label: "Total Spend", key: "formatted_total_spend"},
            {label: "Total Revenue", key: "formatted_total_revenue"},
            {label: "ROI Percentage", key: "roi_percentage"},
        ])
        const idFieldChannel = 'campaign_channel_id';
        const idFieldAsset = 'campaign_asset_id';
        const idFieldMetric = 'campaign_metric_id';
        const idFieldRoi = 'campaign_roi_id';
        const channelsRows = ref([]);
        const assetsRows = ref([]);
        const metricsRows = ref([]);
        const roiRows = ref([]);
        const selectedChannelIds = ref([]);
        const selectedAssetIds = ref([]);
        const selectedMetricIds = ref([]);
        const selectedRoiIds = ref([]);
        const displayDetailsButtons = ref(true);
        const companyID = computed(()=> store.state.userData.company_id);
        const name_search = ref('');
        const status_search = ref('');
        const searchFilters = ref([
            {type:'text', placeholder:"Search Name...", value: name_search},
            {
                type:'dropdown', placeholder:"Status..", value: status_search, width:36,
                options: [{text: 'Draft',value:'Draft'},{text:'Active',value:'Active'},{text:'Paused',value:'Paused'},{text:'Completed',value:'Completed'}]
            },
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const handleChannelChange = (ids) => {
            selectedChannelIds.value = ids;
        };
        const handleAssetChange = (ids) => {
            selectedAssetIds.value = ids;
        };
        const handleMetricChange = (ids) => {
            selectedMetricIds.value = ids;
        };
        const handleRoiChange = (ids) => {
            selectedRoiIds.value = ids;
        };
        const formFields = ref([]);
        const updateFormFields = (campaign) => {
            formFields.value = [
                { type: 'text', name: 'name',label: "Name", value: campaign?.name || '', required: true },
                { type: 'date', name: 'start_date',label: "Start Date", value: campaign?.start_date || '', required: true },
                { type: 'date', name: 'end_date',label: "End Date", value: campaign?.end_date || null, required: false },
                { type: 'number', name: 'budget',label: "Budget", value: campaign?.budget || '', required: true },
                { type: 'text', name: 'assigned_to',label: "Assigned To", value: campaign?.assigned_to || '', required: true },
                { type: 'dropdown', name: 'status',label: "Status", value: campaign?.status || 'Draft', required: true, options: [{text:'Draft',value:'Draft'},{text:'Active',value:'Active'},{text:'Paused',value:'Paused'},{text:'Completed',value:'Completed'}] },
                { type: 'text-area', name: 'objective',label: "Objective", value: campaign?.objective || '', textarea_rows: '3', textarea_cols: '56', required: true },
            ];
        };
        watch(selectedCampaign, (newCampaign) => {
            updateFormFields(newCampaign);
        }, { immediate: true });
        const addNewCampaign = () =>{
            depModalVisible.value = true;
            handleReset();
            store.dispatch("Marketing_Campaigns/updateState",{isEditing:false})
            flex_basis.value = '1/3';
            flex_basis_percentage.value = '33.33';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const campaignID = row[idField];
                let formData = {
                    company: companyID.value,
                    campaign: campaignID
                }
                await store.dispatch('Marketing_Campaigns/fetchMarketingCampaign',formData).
                then(()=>{
                    depModalVisible.value = true;
                    flex_basis.value = '1/3';
                    flex_basis_percentage.value = '33.33';
                })
                
            }else if(action == 'delete'){
                const campaignID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    campaign: campaignID
                }
                await store.dispatch('Marketing_Campaigns/deleteMarketingCampaign',formData).
                then(()=>{
                    searchCampaigns();
                })
            }
        } 
        const handleReset = async() =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            formFields.value[5].value = 'Draft';
            for(let i=0; i < formFields1.value.length; i++){
                formFields1.value[i].value = '';
            }
            for(let i=0; i < formFields2.value.length; i++){
                formFields2.value[i].value = '';
            }
            for(let i=0; i < formFields3.value.length; i++){
                formFields3.value[i].value = '';
            }
            for(let i=0; i < formFields4.value.length; i++){
                formFields4.value[i].value = '';
            }
            custComponentKey.value += 1;
            await store.dispatch('Marketing_Campaigns/updateState',{selectedChannel:null, channelName:''}); 

        }
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createMarketingCampaign = async() =>{
            showModalLoader();
            let formData = {
                name: formFields.value[0].value,
                start_date: formFields.value[1].value,
                end_date: formFields.value[2].value || null,
                budget: formFields.value[3].value,
                assigned_to: formFields.value[4].value,
                status: formFields.value[5].value,
                objective: formFields.value[6].value,
                company: companyID.value
            }
            errors.value = [];
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Marketing_Campaigns/createMarketingCampaign', formData);
                    if(response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Marketing Campaign created successfully!');
                        handleReset();
                    }else {
                        toast.error('An error occurred while creating the Marketing Campaign.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Marketing Campaign: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchCampaigns();
                }
            }

        }
        const updateMarketingCampaign = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                name: formFields.value[0].value,
                start_date: formFields.value[1].value,
                end_date: formFields.value[2].value,
                budget: formFields.value[3].value,
                assigned_to: formFields.value[4].value,
                status: formFields.value[5].value,
                objective: formFields.value[6].value,
                company: companyID.value,
                campaign: selectedCampaign.value.campaign_id
            }
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                    toast.error('Fill In Required Fields');
            }else{
                try {
                    const response = await store.dispatch('Marketing_Campaigns/updateMarketingCampaign', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        toast.success("Marketing Campaign updated successfully!");
                        handleReset();
                    } else {
                        toast.error('An error occurred while updating the Marketing Campaign.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Marketing Campaign: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchCampaigns();
                }
            }
        }
        const saveCampaign = () =>{
            if(isEditing.value == true){
                updateMarketingCampaign();
            }else{
                createMarketingCampaign();
            }
        }
        const removeCampaign = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    campaign: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Marketing_Campaigns/deleteMarketingCampaign',formData)
                    if(response && response.status == 200){
                        toast.success("Marketing Campaign Removed Succesfully");
                        searchCampaigns();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Marketing Campaign: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Marketing Campaign") 
            }else{
                toast.error("Please Select A Marketing Campaign To Remove")
            }
        }
        const removeCampaigns = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    campaign: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Marketing_Campaigns/deleteMarketingCampaign',formData)
                    if(response && response.status == 200){
                        toast.success("Marketing Campaign(s) Removed Succesfully");
                        searchCampaigns();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Marketing Campaign(s): ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else{
                toast.error("Please Select A Marketing Campaign To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchCampaigns = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                name: name_search.value,
                status: status_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            }
            axios
            .post(`api/v1/marketing-campaigns-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                campaignsList.value = response.data.results;
                store.commit('Marketing_Campaigns/LIST_MARKETING_CAMPAIGNS', campaignsList.value)
                depResults.value = response.data;
                depArrLen.value = campaignsList.value.length;
                depCount.value = depResults.value.count;
                pageCount.value = Math.ceil(depCount.value / selectedValue.value);
                
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchCampaigns();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchCampaigns();
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchCampaigns();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchCampaigns();
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchCampaigns(selectedValue.value);
        };
        const dropdownOptions = ref([
             
        ]);
        const handleDynamicOption = async(option) =>{
            
        };
        const resetFilters = () =>{
            name_search.value = "";
            status_search.value = "";
            currentPage.value = 1;
            searchCampaigns();
        };
        const closeModal = async() =>{
            depModalVisible.value = false;
            handleReset();
        };
        const handleShowDetails = async(row) =>{
            activeTab.value = 0;
            campaignID.value = row['campaign_id'];
            detailsTitle.value = row['name'] + ' Details';
            showDetails.value = true;
            let formData = {
                campaign: row['campaign_id'],
                company: companyID.value
            }
            axios.post('api/v1/get-campaign-channels/',formData)
            .then((response)=>{
                channelsRows.value = response.data;
            })
            .catch((error)=>{
                console.log(error.message)
            })
        };
        const selectTab = async(index) => {
            let formData = {
                company: companyID.value,
                campaign: campaignID.value,
            }
            if(index == 1){
                activeTab.value = index;
                await axios.post('api/v1/get-campaign-assets/',formData)
                .then((response)=>{
                    assetsRows.value = response.data;
                })
                .catch((error)=>{
                    console.log(error.message)
                })
            }else if(index == 2){
                activeTab.value = index;
                await axios.post('api/v1/get-campaign-metrics/',formData)
                .then((response)=>{
                    metricsRows.value = response.data;
                })
                .catch((error)=>{
                    console.log(error.message)
                })
            }else if(index == 3){
                activeTab.value = index;
                await axios.post('api/v1/get-campaign-rois/',formData)
                .then((response)=>{
                    roiRows.value = response.data;
                })
                .catch((error)=>{
                    console.log(error.message)
                })
            }else{
                activeTab.value = index;
                hideLoader();
            }

        };
        const hideDetails = async() =>{
            showDetails.value = false;
        };
        const showModalLoader1 = () =>{
            modal_loader1.value = "block";
        }
        const hideModalLoader1 = () =>{
            modal_loader1.value = "none";
        }
        const closeModal1 = () =>{
            handleReset();
            chanModalVisible.value = false;
            hideModalLoader1();
            campaignID.value = '';
            selectedChannelIds.value = [];
            selectedAssetIds.value = [];
            selectedMetricIds.value = [];
            selectedRoiIds.value = [];
        };

        // Campaign Channels Logic

        const fetchChannels = async() =>{
            await store.dispatch('Marketing_Channels/fetchMarketingChannels', {company:companyID.value})
        };
        const handleSelectedChannel = async(option) =>{
            await store.dispatch('Marketing_Channels/handleSelectedChannel', option)
            channelID.value = store.state.Marketing_Channels.channelID;
 
        };
        const clearSelectedChannel = async() =>{
            await store.dispatch('Marketing_Channels/updateState', {channelID: ''});
            channelID.value = ""
        }
        const formFields1 = ref([]);
        const updateFormFields1 = () => {
            formFields1.value = [
                {
                    type:'search-dropdown', label:"Channel", value: channelID.value, componentKey: custComponentKey,
                    selectOptions: channelArray, optionSelected: handleSelectedChannel, required: true,
                    searchPlaceholder: 'Select Channel...', dropdownWidth: '400px', updateValue: channelName.value,
                    clearSearch: clearSelectedChannel()  
                },
                { type: 'number', name: 'allocated_budget',label: "Allocated Budget", value: selectedChannel.value?.allocated_budget || 0, required: true },
                { type: 'number', name: 'actual_spend',label: "Actual Spend", value: selectedChannel.value?.actual_spend || 0, required: false },
                { type: 'number', name: 'leads_generated',label: "Leads Generated", value: selectedChannel.value?.leads_generated || 0, required: false },
            ]
        };
        watch(selectedChannel, () => {
            if(selectedChannel.value){
                custComponentKey.value += 1;
                updateFormFields1();
            }
            
        }, { immediate: true });
        const displayChannels = () =>{
            handleReset();
            fetchChannels();
            chanModalVisible.value = true;
            updateFormFields1();
            flex_basis.value = '1/2';
            flex_basis_percentage.value = '50';
            channelEditing.value = false;
            channelID.value = null;
        };
        const editChannel = async() =>{
            if(selectedChannelIds.value.length == 1){
                const chanID = selectedChannelIds.value[0];
                let formData = {
                    company: companyID.value,
                    campaign_channel: chanID
                }
                await store.dispatch('Marketing_Campaigns/fetchMarketingChannel',formData).
                then(()=>{
                    channelID.value = selectedChannel.value.channel.marketing_channel_id;
                    chanModalVisible.value = true;
                    flex_basis.value = '1/2';
                    flex_basis_percentage.value = '50';
                    channelEditing.value = true;
                })
               
            }
        }
        const removeChannel = async() =>{
            let formData = {
                campaign_channel: selectedChannelIds.value,
                company: companyID.value
            }
            Swal.fire({
            title: "Are you sure?",
            text: `Do you wish to Remove Channel?`,
            type: 'warning',
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: 'Yes Remove Channel!',
            cancelButtonText: 'Cancel!',
            customClass: {
                confirmButton: 'swal2-confirm-custom',
                cancelButton: 'swal2-cancel-custom',
            },
            showLoaderOnConfirm: true,
            }).then((result) => {
            if (result.value) {
                axios.post(`api/v1/delete-campaign-channel/`,formData)
                .then((response)=>{
                    if(response.data.msg == "Success"){
                        Swal.fire("Success!", {
                            icon: "success",
                        }); 
                    }else{
                        Swal.fire({
                        title: "Error Removing Channel",
                        icon: "warning",
                        });
                    }                   
                })
                .catch((error)=>{
                    console.log(error.message);
                    Swal.fire({
                        title: error.message,
                        icon: "warning",
                    });
                })
                .finally(()=>{
                    selectedChannelIds.value = [];
                });
            }else{
                Swal.fire(`Channel has not been removed!`);
            }
            })     
        };
        const channelsField = ref([
            {type: 'add', label: 'Add Channel', icon: 'fa fa-plus', rightName: 'Adding Marketing Campaigns', method: displayChannels},
            {type: 'other', label: 'Edit Channel', icon: 'fa fa-edit', rightName: 'Adding Marketing Campaigns', method: editChannel},
            {type: 'remove', label: 'Remove Channel', icon: 'fa fa-times', rightName: 'Deleting Marketing Campaigns', method: removeChannel},
        ]);
        
        const createChannel = async() =>{
            showModalLoader1();
            let formData = {
                campaign: campaignID.value,
                campaign_id: campaignID.value,
                channel: channelID.value,
                channel_id: channelID.value,
                allocated_budget: formFields1.value[1].value,
                actual_spend: formFields1.value[2].value,
                leads_generated: formFields1.value[3].value,
                company: companyID.value
            }
            try {
                const response = await axios.post('api/v1/create-campaign-channel/',formData);
                if (response && response.status === 201) {
                    toast.success('Success!');
                    closeModal1();
                } else {
                    toast.error('An error occurred while adding the Channel.');
                }
            } catch (error) {
                toast.error('Failed to add Channel: ' + error.message);
            } finally {
                hideModalLoader1();
                chanModalVisible.value = false;
            }
            
        };
        const updateChannel = async() =>{
            showModalLoader1();
            let formData = {
                campaign_channel: selectedChannelIds.value[0],
                campaign: campaignID.value,
                campaign_id: campaignID.value,
                channel: channelID.value,
                channel_id: channelID.value,
                allocated_budget: formFields1.value[1].value,
                actual_spend: formFields1.value[2].value,
                leads_generated: formFields1.value[3].value,
                company: companyID.value
            }
            errors.value = [];
            if(channelID.value == '' || channelID.value == null){
                toast.error('Please Fill In Required Fields');
                hideModalLoader1();
            }
            else{
                try {
                    const response = await axios.put('api/v1/update-campaign-channel/',formData);
                    if (response && response.status === 200) {
                        toast.success('Success!');
                        closeModal1();
                    } else {
                        toast.error('An error occurred while updating the Channel.');
                    }
                } catch (error) {
                    toast.error('Failed to update Channel: ' + error.message);
                } finally {
                    hideModalLoader1();
                    chanModalVisible.value = false;
                }
            }
        };
        const addChannel = () =>{
            if(channelEditing.value == true){
                updateChannel();
            }else{
                createChannel();
            }
        }

        //Campaign Assets Logic

        const handleFileChange = (fileData) => {
            filePath.value = fileData.filePath;
            upload_file.value = fileData.file;

        };
        const assetActions = ref([
            {name: 'preview', icon: 'fa fa-paperclip', title: 'Preview Asset', rightName: 'Adding Marketing Campaigns'},
        ])
        const formFields2 = ref([]);
        const updateFormFields2 = () => {
            formFields2.value = [
                
                { type: 'text', name: 'name',label: "Name", value: '', required: true },
                { type: 'dropdown', name: 'asset_type',label: "Asset Type", value: '', required: true , options: [{text:'Document',value:'Document'},{text:'Image',value:'Image'},{text:'Video',value:'Video'},{text:'Flyer',value:'Flyer'},{text:'Brochure',value:'Brochure'},{text:'Banner',value:'Banner'},{text:'Other',value:'Other'}]},
                { type: 'file', name: 'file-input',label: "Attachment", value: '', filePath: computedFilePath.value, required: false, placeholder: "", accepted_formats: "*/*", method: handleFileChange}
            ]
        };
        const previewDocument = (formData) =>{
            showLoader();
            axios
            .post("api/v1/preview-campaign-asset-document/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const blob1 = new Blob([response.data], { type: 'application/pdf' });
                        const url = URL.createObjectURL(blob1);
                        pdfUrl.value = url;
                        printModalVisible.value = true;
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const handleAssetActionClick = async(rowIndex, action, row) =>{
            if( action == 'preview'){
                const docID = row['campaign_asset_id'];
                let formData = {
                    campaign_asset: docID,
                    company: companyID.value
                } 
                previewDocument(formData);
                
            }
        } 

        const displayAssets = () =>{
            handleReset();
            assetModalVisible.value = true;
            updateFormFields2();
            flex_basis.value = '1/2';
            flex_basis_percentage.value = '50';
        };
        const removeAsset = async() =>{
            let formData = {
                campaign_asset: selectedAssetIds.value,
                company: companyID.value
            }
            Swal.fire({
            title: "Are you sure?",
            text: `Do you wish to Remove Asset?`,
            type: 'warning',
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: 'Yes Remove Asset!',
            cancelButtonText: 'Cancel!',
            customClass: {
                confirmButton: 'swal2-confirm-custom',
                cancelButton: 'swal2-cancel-custom',
            },
            showLoaderOnConfirm: true,
            }).then((result) => {
            if (result.value) {
                axios.post(`api/v1/delete-campaign-asset/`,formData)
                .then((response)=>{
                    if(response.data.msg == "Success"){
                        Swal.fire("Success!", {
                            icon: "success",
                        }); 
                    }else{
                        Swal.fire({
                        title: "Error Removing Asset",
                        icon: "warning",
                        });
                    }                   
                })
                .catch((error)=>{
                    console.log(error.message);
                    Swal.fire({
                        title: error.message,
                        icon: "warning",
                    });
                })
                .finally(()=>{
                    selectedAssetIds.value = [];
                });
            }else{
                Swal.fire(`Asset has not been removed!`);
            }
            })     
        };
        const assetsField = ref([
            {type: 'add', label: 'Add Asset', icon: 'fa fa-plus', rightName: 'Adding Marketing Campaigns', method: displayAssets},
            {type: 'remove', label: 'Remove Asset', icon: 'fa fa-times', rightName: 'Deleting Marketing Campaigns', method: removeAsset},
        ]);
        
        const createAsset = async() =>{
            showModalLoader1();
            let formData = new FormData();
            formData.append('name', formFields2.value[0].value);
            formData.append('asset_type', formFields2.value[1].value);
            formData.append('file', upload_file.value);
            formData.append('campaign', campaignID.value);
            formData.append('campaign_id', campaignID.value);
            formData.append('company', companyID.value);
 
            try {
                const response = await axios.post('api/v1/create-campaign-asset/',formData);
                if (response && response.status === 201) {
                    toast.success('Success!');
                    closeModal1();
                } else {
                    toast.error('An error occurred while adding the Asset.');
                }
            } catch (error) {
                toast.error('Failed to add Asset: ' + error.message);
            } finally {
                hideModalLoader1();
                assetModalVisible.value = false;
            }
            
        };

        //Campaign Metrics Logic

        const formFields3 = ref([]);
        const updateFormFields3 = () => {
            formFields3.value = [
                { type: 'date', name: 'date',label: "Date", value: '', required: true },
                { type: 'number', name: 'impressions',label: "Impressions", value: 0, required: true },
                { type: 'number', name: 'clicks',label: "Clicks", value: 0, required: true },
                { type: 'number', name: 'leads_generated',label: "Leads Generated", value: 0, required: true },
                { type: 'number', name: 'conversions',label: "Conversions", value: 0, required: true },
            ]
        };

        const displayMetrics = () =>{
            handleReset();
            metricModalVisible.value = true;
            updateFormFields3();
            flex_basis.value = '1/2';
            flex_basis_percentage.value = '50';
        };
        const removeMetric = async() =>{
            let formData = {
                campaign_metric: selectedMetricIds.value,
                company: companyID.value
            }
            Swal.fire({
            title: "Are you sure?",
            text: `Do you wish to Remove Metric?`,
            type: 'warning',
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: 'Yes Remove Metric!',
            cancelButtonText: 'Cancel!',
            customClass: {
                confirmButton: 'swal2-confirm-custom',
                cancelButton: 'swal2-cancel-custom',
            },
            showLoaderOnConfirm: true,
            }).then((result) => {
            if (result.value) {
                axios.post(`api/v1/delete-campaign-metric/`,formData)
                .then((response)=>{
                    if(response.data.msg == "Success"){
                        Swal.fire("Success!", {
                            icon: "success",
                        }); 
                    }else{
                        Swal.fire({
                        title: "Error Removing Metric",
                        icon: "warning",
                        });
                    }                   
                })
                .catch((error)=>{
                    console.log(error.message);
                    Swal.fire({
                        title: error.message,
                        icon: "warning",
                    });
                })
                .finally(()=>{
                    selectedMetricIds.value = [];
                });
            }else{
                Swal.fire(`Metric has not been removed!`);
            }
            })     
        };
        const metricsField = ref([
            {type: 'add', label: 'Add Metric', icon: 'fa fa-plus', rightName: 'Adding Marketing Campaigns', method: displayMetrics},
            {type: 'remove', label: 'Remove Metric', icon: 'fa fa-times', rightName: 'Deleting Marketing Campaigns', method: removeMetric},
        ]);

        const createMetric = async() =>{
            showModalLoader1();
            let formData = {
                campaign: campaignID.value,
                campaign_id: campaignID.value,
                date: formFields3.value[0].value,
                impressions: formFields3.value[1].value,
                clicks: formFields3.value[2].value,
                leads_generated: formFields3.value[3].value,
                conversions: formFields3.value[4].value,
                company: companyID.value
            }
            try {
                const response = await axios.post('api/v1/create-campaign-metric/',formData);
                if (response && response.status === 201) {
                    toast.success('Success!');
                    closeModal1();
                } else {
                    toast.error('An error occurred while adding the Metric.');
                }
            } catch (error) {
                toast.error('Failed to add Metric: ' + error.message);
            } finally {
                hideModalLoader1();
                metricModalVisible.value = false;
            }
            
        };

        //Campaign ROIs Logic

        const calculateRoi = (value) =>{
            let total_spend = formFields4.value[0].value;
            let total_revenue = value;
            if(total_spend > 0){
                let roi_percentage = ((total_revenue - total_spend) / total_spend) * 100;
                formFields4.value[2].value = roi_percentage.toFixed(2);
            }else{
                formFields4.value[2].value = 0;
            }
        };
        const formFields4 = ref([]);
        const updateFormFields4 = () => {
            formFields4.value = [
                { type: 'number', name: 'total_spend',label: "Total Spend", value: 0, required: true },
                { type: 'number', name: 'total_revenue',label: "Total Revenue", value: 0, required: true, method: calculateRoi  },
                { type: 'number', name: 'roi_percentage',label: "ROI Percentage(%)", value: 0, required: true},
            ]
        };

        const displayRois = () =>{
            handleReset();
            roiModalVisible.value = true;
            updateFormFields4();
            flex_basis.value = '1/2';
            flex_basis_percentage.value = '50';
        };
        const removeRoi = async() =>{
            let formData = {
                campaign_roi: selectedRoiIds.value,
                company: companyID.value
            }
            Swal.fire({
            title: "Are you sure?",
            text: `Do you wish to Remove ROI?`,
            type: 'warning',
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: 'Yes Remove ROI!',
            cancelButtonText: 'Cancel!',
            customClass: {
                confirmButton: 'swal2-confirm-custom',
                cancelButton: 'swal2-cancel-custom',
            },
            showLoaderOnConfirm: true,
            }).then((result) => {
            if (result.value) {
                axios.post(`api/v1/delete-campaign-roi/`,formData)
                .then((response)=>{
                    if(response.data.msg == "Success"){
                        Swal.fire("Success!", {
                            icon: "success",
                        }); 
                    }else{
                        Swal.fire({
                        title: "Error Removing ROI",
                        icon: "warning",
                        });
                    }                   
                })
                .catch((error)=>{
                    console.log(error.message);
                    Swal.fire({
                        title: error.message,
                        icon: "warning",
                    });
                })
                .finally(()=>{
                    selectedRoiIds.value = [];
                });
            }else{
                Swal.fire(`ROI has not been removed!`);
            }
            })     
        };
        const roiField = ref([
            {type: 'add', label: 'Add ROI', icon: 'fa fa-plus', rightName: 'Adding Marketing Campaigns', method: displayRois},
            {type: 'remove', label: 'Remove ROI', icon: 'fa fa-times', rightName: 'Deleting Marketing Campaigns', method: removeRoi},
        ]);

        const createRoi = async() =>{
            showModalLoader1();
            let formData = {
                campaign: campaignID.value,
                campaign_id: campaignID.value,
                total_spend: formFields4.value[0].value,
                total_revenue: formFields4.value[1].value,
                roi_percentage: formFields4.value[2].value,
                company: companyID.value
            }
            try {
                const response = await axios.post('api/v1/create-campaign-roi/',formData);
                if (response && response.status === 201) {
                    toast.success('Success!');
                    closeModal1();
                } else {
                    toast.error('An error occurred while adding the ROI.');
                }
            } catch (error) {
                toast.error('Failed to add ROI: ' + error.message);
            } finally {
                hideModalLoader1();
                roiModalVisible.value = false;
            }
            
        };

        onMounted(()=>{
            searchCampaigns();
        })
        return{
            title,idField, searchCampaigns, addButtonLabel, searchFilters, resetFilters, tableColumns, campaignsList,handleSelectionChange,
            currentPage,depResults, depArrLen, depCount, pageCount, showNextBtn, showPreviousBtn,modal_top, modal_left, modal_width,
            loadPrev, loadNext, firstPage, lastPage, actions, formFields, depModalVisible, addNewCampaign,title1,title2,title3,title4,
            displayButtons,flex_basis,flex_basis_percentage, handleActionClick, handleReset, saveCampaign,
            showLoader, loader, hideLoader, modal_loader, showModalLoader, hideModalLoader, removeCampaign, removeCampaigns,
            addingRight,removingRight,rightsModule, closeModal,selectedValue, selectSearchQuantity,dropdownOptions, handleDynamicOption,
            showDetails, detailsTitle, handleShowDetails, hideDetails,selectTab,activeTab,tabs,displayDetailsButtons,
            channelColumns,assetColumns,metricColumns,roiColumns,channelsRows,assetsRows,metricsRows,roiRows,channelsField,
            idFieldChannel,idFieldAsset,idFieldMetric,idFieldRoi,handleChannelChange,chanModalVisible,
            displayChannels,formFields1,updateFormFields1,showModalLoader1,hideModalLoader1,modal_loader1,closeModal1,
            addChannel,modal_top1,modal_left1,modal_width1,handleAssetChange,handleMetricChange,handleRoiChange,
            formFields2,assetsField,assetModalVisible,createAsset,handleFileChange,handleAssetActionClick,assetActions,pdfUrl,
            printModalVisible,printTitle,formFields3,metricsField,metricModalVisible,createMetric,formFields4,roiField,roiModalVisible,createRoi,
        }
    }
}
</script>


<style scoped>
.tabs {
    display: flex;
    border-bottom: 1px solid #ccc;
}
.tab {
    padding: 2px 20px 2px 20px;
    cursor: pointer;
}

.tab.active {
    border-bottom: 2px solid #000;
}

.tab-content {
    padding: 1px;
}</style>